// EmailJS Configuration
// To set up EmailJS:
// 1. Go to https://www.emailjs.com/
// 2. Create an account and verify your email
// 3. Create a new service (Gmail recommended)
// 4. Create two email templates:
//    - One for notification emails to solvrcontact@gmail.com
//    - One for auto-reply emails to the form submitter
// 5. Get your public key from Account -> API Keys
// 6. Replace the values below with your actual credentials

export const emailConfig = {
  serviceId: 'service_rr32ptc',                // Your EmailJS service ID
  notificationTemplateId: 'template_a6z4pst',  // Template ID for emails to solvrcontact@gmail.com
  autoReplyTemplateId: 'template_t480pqo',   // Template ID for auto-reply emails
  publicKey: 'QuV2d50-fV5J5DQmF',             // Your EmailJS public key
};

// Google reCAPTCHA Configuration
// To set up reCAPTCHA:
// 1. Go to https://www.google.com/recaptcha/admin
// 2. Create a new site
// 3. Choose reCAPTCHA v2 "I'm not a robot" checkbox
// 4. Add your domain (localhost for development)
// 5. Get your site key
// 6. Replace the value below with your actual site key

export const recaptchaConfig = {
  siteKey: '6LeMflIrAAAAALtjjXsoK5HfWW-QPKzxFhRtVdin' // reCAPTCHA v2 Checkbox site key
}; 